import { UpdateJobItem } from '../../windows-updates/models/update-job-item';
import { UpdateJob } from '../../windows-updates/models/update-job';

export const getIsNewJob = (job: UpdateJob): boolean =>
  job?.osUpdateJobInfo
    ? job.osUpdateJobInfo.version >= 2
    : typeof job?.appUpdateJobInfo?.version !== 'undefined' && job.appUpdateJobInfo.version >= 2;

export const getIsNewJobItem = (jobItem: UpdateJobItem): boolean =>
  jobItem?.osUpdateInfo
    ? jobItem.osUpdateInfo.version >= 2
    : typeof jobItem?.appUpdateInfo?.version !== 'undefined' && jobItem.appUpdateInfo.version >= 2;
